import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

interface AdminFormPageProps {
  title: string
  cardTitle: string
  backTo: string
  loading?: boolean
  /** Tailwind height class for the card skeleton, e.g. 'h-64' or 'h-96'. Default: 'h-64' */
  cardSkeletonClassName?: string
  children: ReactNode
}

export function AdminFormPage({
  title,
  cardTitle,
  backTo,
  loading = false,
  cardSkeletonClassName = 'h-64',
  children,
}: AdminFormPageProps) {
  if (loading) {
    return (
      <div className="mx-auto max-w-2xl space-y-4">
        <Skeleton className="h-8 w-48" />
        <Skeleton className={cn('w-full', cardSkeletonClassName)} />
      </div>
    )
  }

  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <div className="flex items-center gap-4">
        <Button asChild variant="ghost" size="sm">
          <Link to={backTo}>← Back</Link>
        </Button>
        <h1 className="text-3xl font-bold">{title}</h1>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>{cardTitle}</CardTitle>
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </div>
  )
}
